import { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';
import { helpContent } from '../lib/helpContent';

const HelpTip = ({ helpKey, className }) => {
  const [open, setOpen] = useState(false);
  const text = helpContent[helpKey];
  if (!text) return null;

  return (
    <span className={'relative inline-flex ' + (className || '')}>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(!open); }}
        className="text-slate-400 hover:text-[#235894] transition-colors"
        data-testid={`help-tip-${helpKey}`}
      >
        <HelpCircle className="w-4 h-4" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 left-6 top-0 w-64 p-3 bg-white rounded-lg shadow-lg border text-sm text-slate-600 leading-relaxed">
            <button onClick={() => setOpen(false)} className="absolute top-2 right-2 text-slate-300 hover:text-slate-500">
              <X className="w-3 h-3" />
            </button>
            {text}
          </div>
        </>
      )}
    </span>
  );
};

export default HelpTip;
